import { SnackbarProvider, useSnackbar } from "notistack";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { FaFilePdf } from "react-icons/fa";
import Axios from "axios";
import Brackground from "../../../components/Background";
import Container from "../../../components/Container";
import Header from "../../../components/Header";
import Input from "../../../components/Input";
import Navbar from "../../../components/Navbar";
import React from "react";
import Select from "../../../components/select";
import SubmitButton from "../../../components/Button";
import moment from "moment";
import style from "./RelatorioEntrada.module.css";
import { useStepContext } from "@mui/material";
import JC7Logo from "./Logo-JC7.png";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { FaFileExcel } from "react-icons/fa"; // Ícone do Excel

const ExcelJS = require("exceljs");

const RelatorioEntrada = () => {
  useEffect(() => {
    getOp();
    getAutos();
    getOperacoes();
    getPesoLiquido();
    getDocumentos();
    getNavios();
  }, []);

  const { id } = useParams();
  const [navioslist, setNaviosList] = useState([]);
  const usuario = JSON.parse(localStorage.getItem("user_token")).id;
  const [operacoes, setOperacoes] = useState([]);
  const [filter, setFilter] = useState("");
  const [filterType, setFilterType] = useState("NOME_MOTORISTA");
  const [autos, setAutos] = useState([]);
  const [pesoliquido, setPesoLiquido] = useState([]);
  const [documentos, setDocumentos] = useState([]);
  const [navios, setNavios] = useState([]);
  const JC7LogoBase64 =
    "data:image/png;base64,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";
  const navigate = useNavigate();

  const getOp = () => {
    Axios.get(
      "https://portal.jc7transportes.com.br/api/relatorios/operacoes"
    ).then((response) => {
      setNaviosList(response.data);
    });
  };

  const { enqueueSnackbar } = useSnackbar();

  const showAlert = (txt, variant) => {
    enqueueSnackbar(txt, { variant: variant });
  };

  const getOperacoes = () => {
    Axios.get(
      `https://portal.jc7transportes.com.br/api/periodo/carregamento/${id}`
    )
      .then((response) => {
        console.log(response.data);
        setOperacoes(response.data);
      })
      .catch((error) => {
        console.error("Erro ao buscar operações:", error);
      });
  };

  const getAutos = () => {
    Axios.get(`https://portal.jc7transportes.com.br/api/relatorio/autos/${id}`)
      .then((response) => {
        console.log(response.data);
        setAutos(response.data);
      })
      .catch((error) => {
        console.error("Erro ao buscar autos:", error);
      });
  };

  const getPesoLiquido = () => {
    Axios.get(
      `https://portal.jc7transportes.com.br/api/relatorio/pesoliquido/${id}`
    )
      .then((response) => {
        console.log(response.data);
        setPesoLiquido(response.data);
      })
      .catch((error) => {
        console.error("Erro ao buscar Peso Liquido:", error);
      });
  };

  const getDocumentos = () => {
    Axios.get(
      `https://portal.jc7transportes.com.br/api/relatorio/documentos/${id}`
    )
      .then((response) => {
        console.log(response.data);
        setDocumentos(response.data);
      })
      .catch((error) => {
        console.error("Erro ao buscar os Documentos:", error);
      });
  };

  const getNavios = () => {
    Axios.get(`https://portal.jc7transportes.com.br/api/relatorio/navios/${id}`)
      .then((response) => {
        console.log(response.data);
        setNavios(response.data);
      })
      .catch((error) => {
        console.error("Erro ao buscar os Navios:", error);
      });
  };

  const generatePdf = (carregamento) => {
    if (carregamento.STATUS_CARREG === 7) return;
    const pdf = new jsPDF();
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const logoWidth = 30;
    const logoHeight = 30;
    const logoMarginRight = 10; // Margem da direita para o logo
    const column1StartX = 10;
    const column2StartX = pageWidth / 2;
    const columnWidth = pageWidth / 2 - 20;

    // Definindo Helvetica como fonte
    pdf.setFont("Helvetica", "bold");

    // Cabeçalho
    pdf.setFontSize(15);
    pdf.text("Armazém JC7", 10, 15);
    pdf.setFont("Helvetica", "normal");
    pdf.setFontSize(13);
    pdf.text("Rodovia Padre Manoel da Nobrega N°83103", 10, 20);
    pdf.text("(13) 3406-1041", 10, 25);
    pdf.addImage(
      JC7Logo,
      "PNG",
      pageWidth - logoWidth - logoMarginRight,
      10,
      logoWidth,
      logoHeight
    );

    // Título de Bilhete de Pesagem
    pdf.setFontSize(16);
    const bilheteTitle = `DESCARGA \nBILHETE DE PESAGEM N° ${carregamento.ID_CARREGAMENTO}`;
    pdf.text(bilheteTitle, pageWidth / 2, 40, "center");

    // Linha divisória
    pdf.setDrawColor(0);
    pdf.line(10, 45, pageWidth - 10, 45);

    let startY = 50; // Iniciar a posição Y para as informações

    // Motorista
    let motoristaDetailsStartY = startY;
    let motoristaDetailsEndY = addSectionWithBoxMotorista(
      pdf,
      "Motorista",
      formatMotoristaDetails(carregamento),
      column1StartX,
      motoristaDetailsStartY,
      columnWidth,
      false
    );

    // Veículo
    let placaDetailsStartY = startY;
    let placaDetailsEndY = addSectionWithBoxVeiculo(
      pdf,
      "Veículo",
      formatPlacaDetails(carregamento),
      column2StartX,
      placaDetailsStartY,
      columnWidth,
      false
    );

    // Navio e Produto em duas colunas
    startY = Math.max(motoristaDetailsEndY, placaDetailsEndY) + 1;
    let navioSectionY = addSectionWithBox(
      pdf,
      "Navio",
      carregamento.NOME_NAVIO || "N/A",
      column1StartX,
      startY,
      columnWidth,
      true
    );
    let produtoSectionY = addSectionWithBox(
      pdf,
      "Produto",
      carregamento.PRODUTO || "N/A",
      column2StartX,
      startY,
      columnWidth,
      true
    );

    // Cliente e Transportadora em duas colunas
    startY = Math.max(navioSectionY, produtoSectionY) + 1;
    let clientSectionY = addSectionWithBox(
      pdf,
      "Cliente",
      carregamento.NOME_REDUZIDO || "N/A",
      column1StartX,
      startY,
      columnWidth,
      true
    );
    let transportadoraSectionY = addSectionWithBox(
      pdf,
      "Transportadora",
      carregamento.NOME_TRANSP || "N/A",
      column2StartX,
      startY,
      columnWidth,
      true
    );

    // DI e Pedido em duas colunas
    startY = Math.max(clientSectionY, transportadoraSectionY) + 1;
    let diSectionY = addSectionWithBox(
      pdf,
      "DI",
      carregamento.NUMERO_DOC || "N/A",
      column1StartX,
      startY,
      columnWidth,
      true
    );
    let pedidoSectionY = addSectionWithBox(
      pdf,
      "Pedido",
      carregamento.NR_PEDIDO || "N/A",
      column2StartX,
      startY,
      columnWidth,
      true
    );

    // Peso Bruto
    let placaBrutoDetailsStartY = pedidoSectionY + 1;
    let placaBrutoDetailsEndY = addSectionWithBox4(
      pdf,
      "Peso Bruto",
      formatPesoBrutoDetails(carregamento),
      column1StartX,
      placaBrutoDetailsStartY,
      columnWidth,
      false
    );

    // Peso Tara
    let pesoTaraDetailsStartY = diSectionY + 1;
    let pesoTaraDetailsEndY = addSectionWithBox4(
      pdf,
      "Peso Tara",
      formatPesoTaraDetails(carregamento),
      column2StartX,
      pesoTaraDetailsStartY,
      columnWidth,
      false
    );

    // Adiciona a seção "Diferença de Peso"
    let diferencaPesoDetailsStartY = placaBrutoDetailsEndY + 1;
    let diferencaPesoDetailsEndY = addSectionWithBoxPesos(
      pdf,
      "Diferença de Peso",
      formatDiferencaPesoDetails(carregamento),
      column1StartX,
      diferencaPesoDetailsStartY,
      columnWidth,
      false
    );

    // Peso Líquido
    let pesoLiquidoDetailsStartY = pesoTaraDetailsEndY + 1;
    let pesoLiquidoDetailsEndY = addSectionWithBoxPesos(
      pdf,
      "Peso Líquido",
      formatPesoLiquidoDetails(carregamento),
      column2StartX,
      pesoLiquidoDetailsStartY,
      columnWidth,
      false
    );

    // Adiciona a seção "Tipo de Operação"
    let tipoDeOperacaoStartY = diferencaPesoDetailsEndY + 1;
    let tipoDeOperacaoEndY = addSectionWithBoxOp(
      pdf,
      "Tipo de Operação",
      "ENTRADA DE " + carregamento.PRODUTO,
      column1StartX,
      tipoDeOperacaoStartY,
      columnWidth,
      false
    );

    // Tipo de Operação 2
    let tipoDeOperacao2StartY = pesoLiquidoDetailsEndY + 1;
    let tipoDeOperacao2EndY = addSectionWithBoxNotaFiscal(
      pdf,
      "Nota Fiscal",
      formatNotaFiscalDetails(carregamento),
      column2StartX,
      tipoDeOperacao2StartY,
      columnWidth,
      false
    );

    // Preparando para seção de Assinaturas
    const observationsHeight = 20; // Altura da caixa de observações (de uma seção anterior, por exemplo)
    const observationsStartY = pageHeight - 80; // Posição Y inicial para observações (ajuste conforme necessário)
    const signatureSectionStartY = observationsStartY + observationsHeight + 5; // Espaço após a seção de observações
    const signatureSectionHeight = 40; // Altura da seção de assinaturas

    // Assinaturas em duas colunas
    addSignatureSection(
      pdf,
      " Assinatura da Empresa",
      " JC7 Terminais Portuários e Transportes Ltda",
      column1StartX,
      signatureSectionStartY,
      columnWidth
    );
    addSignatureSectionMotorista(
      pdf,
      " Assinatura do Motorista",
      " " + carregamento.NOME_MOTORISTA,
      formatarCPF(carregamento.CPF_MOTORISTA),
      column2StartX,
      signatureSectionStartY,
      columnWidth
    );

    // Linha divisória
    pdf.setDrawColor(0);
    pdf.line(10, 283, pageWidth - 10, 283);

    // Footer
    pdf.setFontSize(9);
    pdf.text(
      "Sistema de Pesagem - CONFIANTEC BALANÇAS\nwww.jc7terminais.com.br",
      pageWidth / 2,
      pageHeight - 10,
      "center"
    );

    // Salvar o PDF
    pdf.save(`Carregamento-${carregamento.ID_CARREGAMENTO}.pdf`);
  };

  function formatDiferencaPesoDetails(carregamento) {
    // Certifique-se de que todos os valores necessários estão presentes
    if (
      carregamento.PESO_BRUTO &&
      carregamento.PESO_TARA &&
      carregamento.PESO_NOTA_FISCAL
    ) {
      const diferencaDePeso =
        carregamento.PESO_BRUTO -
        carregamento.PESO_TARA -
        carregamento.PESO_NOTA_FISCAL;
      const porcentagemDiferenca =
        (diferencaDePeso / carregamento.PESO_NOTA_FISCAL) * 100;

      const diferencaDePesoFormatada = diferencaDePeso.toLocaleString("pt-BR");
      const porcentagemDiferencaFormatada =
        porcentagemDiferenca.toFixed(2).replace(".", ",") + "%";

      return `${diferencaDePesoFormatada} KG (${porcentagemDiferencaFormatada})`;
    } else {
      return "Sem Peso";
    }
  }

  function addSignatureSection(pdf, title, content, startX, startY, width) {
    pdf.setFontSize(10);
    pdf.text(`${title}:`, startX, startY);
    pdf.text(content, startX, startY + 8);
    pdf.setDrawColor(0);
    pdf.setLineWidth(0.2); // Reduzindo a grossura do contorno para 0.2
    pdf.rect(startX, startY - 5, width, 40, "S");
  }

  function addSignatureSectionMotorista(
    pdf,
    title,
    name,
    cpf,
    startX,
    startY,
    width
  ) {
    const lineHeight = 10; // Altura entre linhas
    pdf.setFontSize(10); // Tamanho da fonte para o título
    pdf.text(`${title}:`, startX, startY); // Escreve o título

    pdf.setFont("Helvetica", "normal"); // Define a fonte para normal para o nome
    pdf.setFontSize(9); // Tamanho da fonte para o nome
    pdf.text(name, startX, startY + 5); // Escreve o nome do motorista na linha abaixo do título

    pdf.setFontSize(9); // Tamanho da fonte para o CPF
    pdf.text(` CPF: ${cpf}`, startX, startY + 9); // Escreve o CPF na próxima linha

    // Desenha uma caixa ao redor da seção de assinaturaproduto
    pdf.setDrawColor(0);
    pdf.setLineWidth(0.2); // Define a espessura da linha
    pdf.rect(startX, startY - 5, width, 3 * lineHeight + 10, "S"); // Ajusta o tamanho da caixa para acomodar todo o texto
  }

  function formatPlacaDetails(carregamento) {
    return `Cavalo: ${carregamento.PLACA_CAVALO}      Carreta: ${carregamento.PLACA_CARRETA || "----------"
      }\nCarreta 2: ${carregamento.PLACA_CARRETA2 || "----------"
      }      Carreta 3: ${carregamento.PLACA_CARRETA3 || "----------"}`;
  }

  function formatMotoristaDetails(carregamento) {
    const cpfFormatado = formatarCPF(carregamento.CPF_MOTORISTA); // Supondo que formatarCPF retorne o CPF formatado.
    return `${carregamento.NOME_MOTORISTA}\n CPF: ${cpfFormatado}`;
  }

  function formatarCPF(cpf) {
    // Certifique-se de que o cpf tenha 11 dígitos e esteja em uma string limpa
    return cpf.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, "$1.$2.$3-$4");
  }

  function formatPesoBrutoDetails(carregamento) {
    // Criando um objeto Date a partir da string ISO para garantir a conversão correta
    const dataBruto = new Date(carregamento.DATA_BRUTO);

    // Opções de formatação de data e hora
    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZone: "America/Sao_Paulo",
    };

    return `Data e Hora: ${dataBruto.toLocaleString(
      "pt-BR",
      options
    )}\nPESO: ${carregamento.PESO_BRUTO.toLocaleString("pt-BR")} KG`;
  }

  function formatPesoTaraDetails(carregamento) {
    // Verificar se a DATA_TARA está definida e não é uma string vazia
    let dataTaraString = "Aguardando";
    if (carregamento.DATA_TARA) {
      const dataTara = new Date(carregamento.DATA_TARA);
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        timeZone: "America/Sao_Paulo",
      };
      dataTaraString = dataTara.toLocaleString("pt-BR", options);
    }

    // Verificar se PESO_TARA tem um valor válido e não nulo ou zero
    const pesoTara = carregamento.PESO_TARA
      ? carregamento.PESO_TARA.toLocaleString("pt-BR")
      : "0";

    return `Data e Hora: ${dataTaraString}\nPESO: ${pesoTara} KG`;
  }

  function formatNotaFiscalDetails(carregamento) {
    const pesoNotaFiscal = carregamento.PESO_NOTA_FISCAL
      ? carregamento.PESO_NOTA_FISCAL.toLocaleString("pt-BR")
      : "0";
    const numeroNotaFiscal = carregamento.NUMERO_NOTA_FISCAL;

    return `Número: ${numeroNotaFiscal}, PESO: ${pesoNotaFiscal} KG`;
  }

  function formatPesoLiquidoDetails(carregamento) {
    // Calcular o peso líquido se ambos os valores de peso bruto e tara estão disponíveis
    const pesoLiquido =
      carregamento.PESO_BRUTO && carregamento.PESO_TARA
        ? carregamento.PESO_BRUTO - carregamento.PESO_TARA
        : 0;
    const pesoLiquidoFormatado = pesoLiquido.toLocaleString("pt-BR");

    // Verificar se a data do peso bruto está disponível para usar como referência
    let dataPesoBrutoString = "Aguardando";
    if (carregamento.DATA_BRUTO) {
      const dataPesoBruto = new Date(carregamento.DATA_BRUTO);
      const options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        timeZone: "America/Sao_Paulo",
      };
      dataPesoBrutoString = dataPesoBruto.toLocaleString("pt-BR", options);
    }

    return `${pesoLiquidoFormatado} KG`;
  }

  function addSectionWithBox(
    pdf,
    title,
    content,
    startX,
    startY,
    width,
    boldContent = false
  ) {
    const cornerRadius = 2; // Define the radius for the rounded corners
    const lineHeight = 6; // Define the line height for better control
    const sectionHeight = 18; // Define the section height for better control

    pdf.setFontSize(11);
    pdf.setFont("Helvetica", "normal"); // Sempre definir fonte em negrito para o título

    // Posicionar o título à esquerda na caixa
    const titleX = startX + 2; // Pequeno deslocamento da borda esquerda
    pdf.text(`${title}:`, titleX, startY + lineHeight); // Ajustar posição vertical

    // Configurar a fonte para o conteúdo
    pdf.setFont("Helvetica", "bold"); // Voltar para fonte normal para o conteúdo
    pdf.setFontSize(12); // Definir tamanho da fonte para o conteúdo

    // Centralizar o conteúdo na caixa
    const contentWidth =
      (pdf.getStringUnitWidth(content) * pdf.internal.getFontSize()) /
      pdf.internal.scaleFactor;
    const contentX = startX + (width - contentWidth) / 2; // Calcular a posição x para centralizar o conteúdo

    pdf.text(content, contentX, startY + lineHeight * 2.5); // Ajustar posição vertical

    pdf.setDrawColor(0);
    pdf.setLineWidth(0.2); // Definir a largura da linha para a caixa
    // Desenhar um retângulo arredondado ao redor da seção
    pdf.roundedRect(
      startX,
      startY,
      width,
      sectionHeight,
      cornerRadius,
      cornerRadius,
      "S"
    );
    return startY + sectionHeight + lineHeight; // Retornar a posição y após a seção para uso posterior
  }

  function addSectionWithBoxMotorista(
    pdf,
    title,
    content,
    startX,
    startY,
    width,
    boldContent = false
  ) {
    const cornerRadius = 2; // Raio para os cantos arredondados
    const lineHeight = 6; // Altura da linha para melhor controle
    const sectionHeight = 23; // Altura total da seção para melhor controle

    pdf.setFontSize(11);
    pdf.setFont("Helvetica", "normal"); // Sempre definir fonte em negrito para o título

    // Posicionar o título à esquerda na caixa
    const titleX = startX + 2; // Pequeno deslocamento da borda esquerda
    pdf.text(`${title}:`, titleX, startY + lineHeight); // Ajustar posição vertical

    // Configurar a fonte para o conteúdo
    pdf.setFont("Helvetica", "bold"); // Voltar para fonte normal para o conteúdo
    pdf.setFontSize(12); // Definir tamanho da fonte para o conteúdo

    // Centralizar o conteúdo na caixa
    const contentWidth =
      (pdf.getStringUnitWidth(content) * pdf.internal.getFontSize()) /
      pdf.internal.scaleFactor;
    const contentX = startX + (width - contentWidth) / 2 + 20; // Calcular a posição x para centralizar o conteúdo

    pdf.text(content, contentX, startY + lineHeight * 2.5); // Ajustar posição vertical

    pdf.setDrawColor(0);
    pdf.setLineWidth(0.2); // Definir a largura da linha para a caixa
    // Desenhar um retângulo arredondado ao redor da seção
    pdf.roundedRect(
      startX,
      startY,
      width,
      sectionHeight,
      cornerRadius,
      cornerRadius,
      "S"
    );
    return startY + sectionHeight + lineHeight; // Retornar a posição y após a seção para uso posterior
  }

  function addSectionWithBoxVeiculo(
    pdf,
    title,
    content,
    startX,
    startY,
    width,
    boldContent = false
  ) {
    const cornerRadius = 2; // Raio para os cantos arredondados
    const lineHeight = 6; // Altura da linha para melhor controle
    const sectionHeight = 23; // Altura total da seção para melhor controle

    pdf.setFontSize(11);
    pdf.setFont("Helvetica", "normal"); // Sempre definir fonte em negrito para o título

    // Posicionar o título à esquerda na caixa
    const titleX = startX + 2; // Pequeno deslocamento da borda esquerda
    pdf.text(`${title}:`, titleX, startY + lineHeight); // Ajustar posição vertical

    // Configurar a fonte para o conteúdo
    pdf.setFont("Helvetica", "bold"); // Voltar para fonte normal para o conteúdo
    pdf.setFontSize(12); // Definir tamanho da fonte para o conteúdo

    // Centralizar o conteúdo na caixa
    const contentWidth =
      (pdf.getStringUnitWidth(content) * pdf.internal.getFontSize()) /
      pdf.internal.scaleFactor;
    const contentX = startX + (width - contentWidth) / 2 + 39; // Calcular a posição x para centralizar o conteúdo

    pdf.text(content, contentX, startY + lineHeight * 2.5); // Ajustar posição vertical

    pdf.setDrawColor(0);
    pdf.setLineWidth(0.2); // Definir a largura da linha para a caixa
    // Desenhar um retângulo arredondado ao redor da seção
    pdf.roundedRect(
      startX,
      startY,
      width,
      sectionHeight,
      cornerRadius,
      cornerRadius,
      "S"
    );
    return startY + sectionHeight + lineHeight; // Retornar a posição y após a seção para uso posterior
  }

  function addSectionWithBoxNotaFiscal(
    pdf,
    title,
    content,
    startX,
    startY,
    width,
    boldContent = false
  ) {
    const cornerRadius = 2; // Raio para os cantos arredondados
    const lineHeight = 6; // Altura da linha para melhor controle
    const sectionHeight = 20; // Altura total da seção para melhor controle

    pdf.setFontSize(11);
    pdf.setFont("Helvetica", "normal"); // Sempre definir fonte em negrito para o título

    // Posicionar o título à esquerda na caixa
    const titleX = startX + 2; // Pequeno deslocamento da borda esquerda
    pdf.text(`${title}:`, titleX, startY + lineHeight); // Ajustar posição vertical

    // Configurar a fonte para o conteúdo
    pdf.setFont("Helvetica", "bold"); // Voltar para fonte normal para o conteúdo
    pdf.setFontSize(12); // Definir tamanho da fonte para o conteúdo

    // Centralizar o conteúdo na caixa
    const contentWidth =
      (pdf.getStringUnitWidth(content) * pdf.internal.getFontSize()) /
      pdf.internal.scaleFactor;
    const contentX = startX + (width - contentWidth) / 2; // Calcular a posição x para centralizar o conteúdo

    pdf.text(content, contentX, startY + lineHeight * 2.5); // Ajustar posição vertical

    pdf.setDrawColor(0);
    pdf.setLineWidth(0.2); // Definir a largura da linha para a caixa
    // Desenhar um retângulo arredondado ao redor da seção
    pdf.roundedRect(
      startX,
      startY,
      width,
      sectionHeight,
      cornerRadius,
      cornerRadius,
      "S"
    );
    return startY + sectionHeight + lineHeight; // Retornar a posição y após a seção para uso posterior
  }

  function addSectionWithBox4(
    pdf,
    title,
    content,
    startX,
    startY,
    width,
    boldContent = false
  ) {
    const cornerRadius = 2; // Raio para os cantos arredondados
    const lineHeight = 6; // Altura da linha para melhor controle
    const sectionHeight = 25; // Altura total da seção para melhor controle

    pdf.setFontSize(11);
    pdf.setFont("Helvetica", "normal"); // Sempre definir fonte em negrito para o título

    // Posicionar o título à esquerda na caixa
    const titleX = startX + 2; // Pequeno deslocamento da borda esquerda
    pdf.text(`${title}:`, titleX, startY + lineHeight); // Ajustar posição vertical

    // Configurar a fonte para o conteúdo
    pdf.setFont("Helvetica", "bold"); // Voltar para fonte normal para o conteúdo
    pdf.setFontSize(12); // Definir tamanho da fonte para o conteúdo

    // Centralizar o conteúdo na caixa
    const contentWidth =
      (pdf.getStringUnitWidth(content) * pdf.internal.getFontSize()) /
      pdf.internal.scaleFactor;
    const contentX = startX + (width - contentWidth) / 2 + 16; // Calcular a posição x para centralizar o conteúdo

    pdf.text(content, contentX, startY + lineHeight * 2.5); // Ajustar posição vertical

    pdf.setDrawColor(0);
    pdf.setLineWidth(0.2); // Definir a largura da linha para a caixa
    // Desenhar um retângulo arredondado ao redor da seção
    pdf.roundedRect(
      startX,
      startY,
      width,
      sectionHeight,
      cornerRadius,
      cornerRadius,
      "S"
    );
    return startY + sectionHeight + lineHeight; // Retornar a posição y após a seção para uso posterior
  }

  function addSectionWithBoxPesos(
    pdf,
    title,
    content,
    startX,
    startY,
    width,
    boldContent = false
  ) {
    const cornerRadius = 2; // Raio para os cantos arredondados
    const lineHeight = 6; // Altura da linha para melhor controle
    const sectionHeight = 20; // Altura total da seção para melhor controle

    pdf.setFontSize(11);
    pdf.setFont("Helvetica", "normal"); // Sempre definir fonte em negrito para o título

    // Posicionar o título à esquerda na caixa
    const titleX = startX + 2; // Pequeno deslocamento da borda esquerda
    pdf.text(`${title}:`, titleX, startY + lineHeight); // Ajustar posição vertical

    // Configurar a fonte para o conteúdo
    pdf.setFont("Helvetica", "bold"); // Voltar para fonte normal para o conteúdo
    pdf.setFontSize(18); // Definir tamanho da fonte para o conteúdo

    // Centralizar o conteúdo na caixa
    const contentWidth =
      (pdf.getStringUnitWidth(content) * pdf.internal.getFontSize()) /
      pdf.internal.scaleFactor;
    const contentX = startX + (width - contentWidth) / 2; // Calcular a posição x para centralizar o conteúdo

    pdf.text(content, contentX, startY + lineHeight * 2.5); // Ajustar posição vertical

    pdf.setDrawColor(0);
    pdf.setLineWidth(0.2); // Definir a largura da linha para a caixa
    // Desenhar um retângulo arredondado ao redor da seção
    pdf.roundedRect(
      startX,
      startY,
      width,
      sectionHeight,
      cornerRadius,
      cornerRadius,
      "S"
    );
    return startY + sectionHeight + lineHeight; // Retornar a posição y após a seção para uso posterior
  }

  function addSectionWithBoxOp(
    pdf,
    title,
    content,
    startX,
    startY,
    width,
    boldContent = false
  ) {
    const cornerRadius = 2; // Raio para os cantos arredondados
    const lineHeight = 6; // Altura da linha para melhor controle
    const sectionHeight = 20; // Altura total da seção para melhor controle

    pdf.setFontSize(10);
    pdf.setFont("Helvetica", "normal"); // Sempre definir fonte em negrito para o título

    // Posicionar o título à esquerda na caixa
    const titleX = startX + 2; // Pequeno deslocamento da borda esquerda
    pdf.text(`${title}:`, titleX, startY + lineHeight); // Ajustar posição vertical

    // Configurar a fonte para o conteúdo
    pdf.setFont("Helvetica", "bold"); // Voltar para fonte normal para o conteúdo
    pdf.setFontSize(12); // Definir tamanho da fonte para o conteúdo

    // Centralizar o conteúdo na caixa
    const contentWidth =
      (pdf.getStringUnitWidth(content) * pdf.internal.getFontSize()) /
      pdf.internal.scaleFactor;
    const contentX = startX + (width - contentWidth) / 2; // Calcular a posição x para centralizar o conteúdo

    pdf.text(content, contentX, startY + lineHeight * 2.5); // Ajustar posição vertical

    pdf.setDrawColor(0);
    pdf.setLineWidth(0.2); // Definir a largura da linha para a caixa
    // Desenhar um retângulo arredondado ao redor da seção
    pdf.roundedRect(
      startX,
      startY,
      width,
      sectionHeight,
      cornerRadius,
      cornerRadius,
      "S"
    );
    return startY + sectionHeight + lineHeight; // Retornar a posição y após a seção para uso posterior
  }

  const [busca, setBusca] = useState("");

  const formatarNomeMotorista = (nomeCompleto) => {
    const partesDoNome = nomeCompleto.split(" ");
    if (partesDoNome.length > 1) {
      return `${partesDoNome[0]} ${partesDoNome[partesDoNome.length - 1]}`;
    }
    return nomeCompleto; // Retorna o nome original se ele não tiver sobrenome
  };

  const exportToExcel = (apiData, fileName) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Data");

    // Adiciona o logotipo
    const imageId = workbook.addImage({
      base64: JC7LogoBase64,
      extension: "png",
    });

    worksheet.addImage(imageId, {
      tl: { col: 0, row: 0 },
      ext: { width: 200, height: 60 },
    });

    // Define o estilo do cabeçalho
    const headerStyle = {
      fill: {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "808080" }, // Cor azul
      },
      font: {
        bold: true,
        color: { argb: "FFFFFFFF" }, // Cor da fonte branca
      },
    };

// Cabeçalhos personalizados (com NR_PEDIDO após DI)
const headers = [
  { header: "ID Carregamento", key: "ID_CARREGAMENTO" },
  { header: "Placa do Cavalo", key: "PLACA_CAVALO" },
  { header: "Peso Tara (kg)", key: "PESO_TARA" },
  { header: "Data Tara", key: "DATA_TARA" },
  { header: "Peso Bruto (kg)", key: "PESO_BRUTO" },
  { header: "Número Lacre", key: "NUMERO_LACRE" },
  { header: "Número Container", key: "NUMERO_CONTEINER" },
  { header: "Nº Nota Fiscal", key: "NUMERO_NOTA_FISCAL" },
  { header: "Peso Nota Fiscal (kg)", key: "PESO_NOTA_FISCAL" },
  { header: "Peso Líquido (kg)", key: "PESO_LIQUIDO" },
  { header: "DI", key: "NUMERO_DOC" },
  { header: "Pedido", key: "NR_PEDIDO" },
  { header: "Motorista", key: "NOME_MOTORISTA" },
  { header: "CPF Motorista", key: "CPF_MOTORISTA" },
  { header: "Navio", key: "NOME_NAVIO" },
  { header: "Produto", key: "PRODUTO" },
  { header: "Cliente", key: "NOME_CLIENTE" },
  { header: "Transportadora", key: "NOME_TRANSP" },
];

    // Adiciona três linhas em branco antes do cabeçalho
    worksheet.addRow([]);
    worksheet.addRow([]);
    worksheet.addRow([]);

    // Adiciona os cabeçalhos ao worksheet na linha 4
    const headerRow = worksheet.addRow(headers.map((h) => h.header));
    headerRow.eachCell((cell, colNumber) => {
      cell.style = headerStyle;
      worksheet.getColumn(colNumber).alignment = {
        vertical: "middle",
        horizontal: "center",
      };
    });

    // Define as colunas do worksheet
    worksheet.columns = headers.map((col, index) => ({
      key: col.key,
      width: 20, // largura inicial da coluna
    }));

    // Filtra os dados para excluir os carregamentos com STATUS_CARREG igual a 7
    const filteredData = apiData.filter((item) => item.STATUS_CARREG !== 7);

    // Adiciona os dados a partir da linha 5
    filteredData.forEach((item, index) => {
      const pesoLiquido = item.PESO_BRUTO - item.PESO_TARA; // Calcula o peso líquido
      const rowData = {
        ...item,
        PESO_LIQUIDO: pesoLiquido,
        PESO_BRUTO: item.PESO_BRUTO,
        PESO_NOTA_FISCAL: item.PESO_NOTA_FISCAL,
        PESO_TARA: item.PESO_TARA,
        DATA_TARA: moment(item.DATA_TARA).format("DD/MM/YYYY"),
        CPF_MOTORISTA: formatarCPF(item.CPF_MOTORISTA),
        NUMERO_LACRE: item.NUMERO_LACRE || "N/A",
        NUMERO_CONTAINER: item.NUMERO_CONTEINER || "N/A",
      };
      const row = worksheet.addRow(rowData);
      row.commit();

      // Centraliza o conteúdo das células
      row.eachCell({ includeEmpty: true }, (cell) => {
        cell.alignment = { vertical: "middle", horizontal: "center" };
      });
    });

    // Ajusta automaticamente a largura das colunas
    worksheet.columns.forEach((column) => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const cellValue = cell.value ? cell.value.toString() : "";
        maxLength = Math.max(maxLength, cellValue.length);
      });
      column.width = maxLength + 2; // Adiciona um pouco de espaço extra
    });

    workbook.xlsx.writeBuffer().then((excelBuffer) => {
      // Ajustar o nome do arquivo com base em NOME_NAVIO e COD_OPERACAO
      const navio = apiData[0]["NOME_NAVIO"]; // Assumindo que todos os registros têm o mesmo NOME_NAVIO
      const codOperacao = apiData[0]["COD_OPERACAO"]; // Assumindo que todos os registros têm o mesmo COD_OPERACAO
      const dynamicFileName = `${navio}-${codOperacao}-ENTRADA.xlsx`;

      const data = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      FileSaver.saveAs(data, dynamicFileName);
    });
  };

  const traduzirTipoPesagem = (tipo) => {
    switch (tipo) {
      case "G":
        return "Granel";
      case "C":
        return "Container";
      case "B":
        return "Big Bag";
      default:
        return tipo;
    }
  };

  const sendEmail = () => {
    // Suponha que você queira enviar informações de um carregamento específico
    const codOperacao = operacoes[0].COD_OPERACAO; // Exemplo para pegar o ID do primeiro carregamento

    Axios.post(
      "https://portal.jc7transportes.com.br/api/carregamentos/enviar-email",
      { COD_OPERACAO: codOperacao }
    )
      .then((response) => {
        showAlert("E-mail enviado com sucesso!", "success");
      })
      .catch((error) => {
        showAlert("Erro ao enviar e-mail: " + error.message, "error");
      });
  };

  const handleFilterChange = (e) => {
    setFilter(e.target.value);
  };

  const handleFilterTypeChange = (e) => {
    setFilterType(e.target.value);
  };

  const filteredOperacoes = operacoes.filter((operacao) => {
    const filterLowerCase = filter.toLowerCase();
    switch (filterType) {
      case "NOME_MOTORISTA":
        return operacao.NOME_MOTORISTA.toLowerCase().includes(filterLowerCase);
      case "NOME_REDUZIDO_TRANSP":
        return operacao.NOME_REDUZIDO_TRANSP.toLowerCase().includes(
          filterLowerCase
        );
      case "PLACA_CAVALO":
        return operacao.PLACA_CAVALO.toLowerCase().includes(filterLowerCase);
      case "REFERENCIA":
        return operacao.REFERENCIA.toLowerCase().includes(filterLowerCase);
      case "NUMERO_NOTA_FISCAL":
        return (
          operacao.NUMERO_NOTA_FISCAL &&
          operacao.NUMERO_NOTA_FISCAL.toString()
            .toLowerCase()
            .includes(filterLowerCase)
        );
      case "PLACA_CARRETA":
        return (
          (operacao.PLACA_CARRETA &&
            operacao.PLACA_CARRETA.toLowerCase().includes(filterLowerCase)) ||
          (operacao.PLACA_CARRETA2 &&
            operacao.PLACA_CARRETA2.toLowerCase().includes(filterLowerCase)) ||
          (operacao.PLACA_CARRETA3 &&
            operacao.PLACA_CARRETA3.toLowerCase().includes(filterLowerCase))
        );
      default:
        return true;
    }
  });

  return (
    <>
      <Navbar relatorios />
      <Header />
      <Brackground />
      <Container>
        <div className={style.content}>
          <div className={style.nav}>
            <div
              className={style.navbar}
              onClick={() => navigate(`/relatorios`)}
            >
              Selecione um navio
            </div>
            <div className={style.active}>Relatório de ENTRADA</div>
            <div
              className={style.navbar}
              onClick={() => navigate(`/relatorios/saida/${id}`)}
            >
              Relatório de SAÍDA
            </div>
            <div className={style.navioNome} style={{ marginLeft: "auto" }}>
              {navios.map((val) => (
                <span className={style.navioNome}>
                  <i className="fa fa-ship icon"></i> {val.NOME_NAVIO}
                </span>
              ))}
            </div>
          </div>

          <div className={style.container}>
            <div className={style.cardsTopBar}>
              {documentos.map((documento, index) => (
                <div key={index} className={style.progressContainer}>
                  <label className={style.progressLabel}>
                    DI/BL: {documento.NUMERO_DOC}{" "}
                  </label>
                  <label className={style.progressLabel}>
                    Quantidade Manifestada:{" "}
                    {documento.QTDE_MANIFESTADA.toLocaleString("pt-BR")} KG
                  </label>
                  <label className={style.progressLabel}>
                    Descarregado:{" "}
                    {documento.PESO_LIQUIDO_DOC.toLocaleString("pt-BR")} KG{" "}
                  </label>
                  <label className={style.progressLabel}>
                    Saldo:{" "}
                    {(
                      documento.QTDE_MANIFESTADA - documento.PESO_LIQUIDO_DOC
                    ).toLocaleString("pt-BR")}{" "}
                    KG{" "}
                  </label>

                  <div
                    className={style.progressBar}
                    style={{ height: "20px", backgroundColor: "#e0e0e0" }}
                  >
                    <div
                      style={{
                        width: `${(
                          (documento.PESO_LIQUIDO_DOC /
                            documento.QTDE_MANIFESTADA) *
                          100
                        ).toFixed(2)}%`,
                        backgroundColor: "#90caf9",
                        display: "inline-block",
                      }}
                      title={`Descarregado: ${(
                        (documento.PESO_LIQUIDO_DOC /
                          documento.QTDE_MANIFESTADA) *
                        100
                      ).toFixed(2)}%`}
                    ></div>
                  </div>
                  <div className={style.progressPercentage}>
                    {(
                      (documento.PESO_LIQUIDO_DOC /
                        documento.QTDE_MANIFESTADA) *
                      100
                    ).toFixed(2)}
                    %
                  </div>
                </div>
              ))}
            </div>

            <section className={style.cards}>
              <div className={style.card}>
                <i className="fa fa-truck icon"></i>
                <p className={style.total}>
                  <b>Descarregado</b>
                </p>
                {autos.map((val) => (
                  <span className={style.total}>
                    {val.QTDE_AUTOS_COM_PESO} Autos
                  </span>
                ))}
              </div>

              <div className={style.card}>
                <i className="fa fa-truck icon"></i>
                <p className={style.total}>
                  <b>Descarregando (Armazém)</b>
                </p>
                {autos.map((val) => (
                  <span className={style.total}>
                    {val.QTDE_AUTOS_SEM_PESO} Autos
                  </span>
                ))}
              </div>

              <div className={style.card}>
                <i className="fa fa-balance-scale"></i>
                <p className={style.total}>
                  <b>Peso Líquido</b>
                </p>
                {pesoliquido.map((val) => (
                  <span className={style.total}>
                    {val.PESO_LIQUIDO.toLocaleString("pt-BR")} KG
                  </span>
                ))}
              </div>

              <div className={style.card}>
                <i className="fa fa-file"></i>
                <p className={style.total}>
                  <b>Descarregado de DI</b>
                </p>
                {documentos.map((val) => (
                  <div className={style.details}>
                    <span>{val.NUMERO_DOC}</span> |{" "}
                    {(val.PESO_LIQUIDO_DOC / 1000).toLocaleString("pt-BR", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}{" "}
                    Tons | {val.QTDE_AUTOS_DOC} Autos
                  </div>
                ))}
              </div>
            </section>
          </div>

          <div className={style.iconcontainer}>
            <div className={style.searchBox}>
              <select
                value={filterType}
                onChange={(e) => setFilterType(e.target.value)}
              >
                <option value="NOME_MOTORISTA">Motorista</option>
                <option value="NOME_REDUZIDO_TRANSP">Transportadora</option>
                <option value="PLACA_CAVALO">Placa do Cavalo</option>
                <option value="PLACA_CARRETA">Placa da Carreta</option>
                <option value="REFERENCIA">DI/BL</option>
                <option value="NUMERO_NOTA_FISCAL">N° Nota Fiscal</option>
              </select>
              <input
                type="text"
                placeholder="Pesquisar..."
                value={filter}
                onChange={handleFilterChange}
              />
            </div>

            <button onClick={sendEmail} className={style.botaoEmail}>
              Enviar por Email
            </button>

            <FaFileExcel
              onClick={() => exportToExcel(operacoes, "RelatorioEntrada")}
              className={style.excelIcon}
            />
          </div>

          <table className={style.table}>
            <thead>
              <tr>
                <th>
                  <abbr title="ID">ID</abbr>
                </th>
                <th>
                  <abbr title="Nome">Motorista</abbr>
                </th>
                <th>
                  <abbr title="Placa do Cavalo">Placa (Cavalo)</abbr>
                </th>
                <th>
                  <abbr title="Tara">1° Peso (BRUTO)</abbr>
                </th>
                <th>
                  <abbr title="Data Carregado">Data BRUTO</abbr>
                </th>
                <th>
                  <abbr title="Terceiro Peso">2° Peso (TARA)</abbr>
                </th>
                <th>
                  <abbr title="Peso Líquido">Peso Líquido</abbr>
                </th>
                <th>
                  <abbr title="Documento">DI/BL</abbr>
                </th>
                <th>
                  <abbr title="Pedido">Pedido</abbr>
                </th>
                <th>
                  <abbr title="Peso Nota Fiscal">Peso N.F.</abbr>
                </th>
                <th>
                  <abbr title="Diferença PESO (NF-PL)">
                    Dif. Peso (N.F.-PL.)
                  </abbr>
                </th>
                <th>
                  <abbr title="Big Bags">Big Bags</abbr>
                </th>
                <th>
                  <abbr title="Transportadora">Transp.</abbr>
                </th>
                <th>
                  <abbr title="Usuário Carregado">Usuário</abbr>
                </th>
                <th>
                  <abbr title="PDF">PDF</abbr>
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredOperacoes.map((val, index) => (
                <tr
                  key={index}
                  className={
                    val.STATUS_CARREG === 7
                      ? style.strikethrough
                      : val.PESO_TARA === null ||
                        val.DATA_TARA === null ||
                        val.USUARIO_TARA === null
                        ? style.highlight
                        : undefined
                  }
                >
                  <td>{val.ID_CARREGAMENTO}</td>
                  <td>{formatarNomeMotorista(val.NOME_MOTORISTA)}</td>
                  <td className={style.tooltip}>
                    {val.PLACA_CAVALO}
                    {(val.PLACA_CARRETA || val.PLACA_CARRETA2) && (
                      <div className={style.tooltiptext}>
                        Carreta 1: {val.PLACA_CARRETA || "N/A"}
                        <br />
                        Carreta 2: {val.PLACA_CARRETA2 || "N/A"}
                        <br />
                        Carreta 3: {val.PLACA_CARRETA3 || "N/A"}
                      </div>
                    )}
                  </td>
                  <td>
                    {val.PESO_BRUTO.toLocaleString(undefined, {
                      maximumFractionDigits: 2,
                    })}{" "}
                    KG
                  </td>
                  <td>{moment(val.DATA_BRUTO).format("DD/MM - HH:mm")}</td>
                  <td>
                    {val.PESO_TARA !== null
                      ? val.PESO_TARA.toLocaleString(undefined, {
                        maximumFractionDigits: 2,
                      })
                      : "0"}{" "}
                    KG
                  </td>
                  <td>
                    {val.PESO_BRUTO && val.PESO_TARA
                      ? (val.PESO_BRUTO - val.PESO_TARA).toLocaleString(
                        undefined,
                        { maximumFractionDigits: 2 }
                      )
                      : "0"}{" "}
                    KG
                  </td>
                  <td>{val.REFERENCIA}</td>
                  <td>{val.NR_PEDIDO}</td>
                  <td className={style.tooltip}>
                    {val.PESO_NOTA_FISCAL
                      ? `${val.PESO_NOTA_FISCAL.toLocaleString(undefined, {
                        maximumFractionDigits: 2,
                      })} KG`
                      : "N/A"}
                    {(val.PLACA_CARRETA || val.PLACA_CARRETA2) && (
                      <div className={style.tooltiptext}>
                        N° N.F.: {val.NUMERO_NOTA_FISCAL || "N/A"}
                        <br />
                      </div>
                    )}
                  </td>
                  <td>
                    {val.PESO_NOTA_FISCAL
                      ? `${(
                        val.PESO_BRUTO -
                        val.PESO_TARA -
                        val.PESO_NOTA_FISCAL
                      ).toLocaleString(undefined, {
                        maximumFractionDigits: 2,
                      })} KG`
                      : "N/A"}
                  </td>
                  <td>
                    {val.QTDA_BIG_BAG != null && val.PESO_BIG_BAG != null
                      ? `${val.QTDA_BIG_BAG
                      } Un - ${val.PESO_BIG_BAG.toLocaleString(undefined, {
                        maximumFractionDigits: 2,
                      })} KG`
                      : ""}
                  </td>
                  <td>{val.NOME_REDUZIDO_TRANSP}</td>
                  <td>{val.USUARIO_BRUTO}</td>
                  <td>
                    <FaFilePdf
                      onClick={() => generatePdf(val)}
                      style={{ cursor: "pointer" }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Container>
    </>
  );
};

export default function IntegrationNotistack() {
  return (
    <SnackbarProvider
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      maxSnack={3}
      autoHideDuration={2500}
    >
      <RelatorioEntrada />
    </SnackbarProvider>
  );
}
